import { useState } from "react";
import { FAQS } from "@/mocks/gossip";
import SectionHeading from "./SectionHeading";

const FAQ_JSON_LD = {
  "@context": "https://schema.org",
  "@type": "FAQPage",
  mainEntity: FAQS.map((f) => ({
    "@type": "Question",
    name: f.q,
    acceptedAnswer: { "@type": "Answer", text: f.a },
  })),
};

export default function FAQ() {
  const [openIdx, setOpenIdx] = useState<number>(0);

  return (
    <section id="faq" className="w-full bg-background-50 py-16 md:py-20">
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(FAQ_JSON_LD) }}
      />
      <div className="mx-auto grid w-full max-w-7xl grid-cols-1 gap-10 px-4 md:px-6 lg:grid-cols-[5fr_7fr] lg:gap-16">
        <div className="lg:sticky lg:top-24 lg:self-start">
          <SectionHeading
            eyebrow="常见问题"
            title="关于追更，你可能想问的"
            desc="关于合集顺序、状态标签与信息来源的常见疑问，我们整理在一处。如果没找到答案，也可以来信或在线索区告诉我们。"
          />
          <div className="mt-6 flex flex-wrap gap-2">
            <span className="inline-flex items-center gap-1.5 whitespace-nowrap rounded-full bg-accent-100 px-3.5 py-1.5 text-xs font-bold text-accent-800">
              <i className="ri-check-double-line" />
              顺序清晰
            </span>
            <span className="inline-flex items-center gap-1.5 whitespace-nowrap rounded-full bg-accent-100 px-3.5 py-1.5 text-xs font-bold text-accent-800">
              <i className="ri-time-line" />
              持续归档
            </span>
            <span className="inline-flex items-center gap-1.5 whitespace-nowrap rounded-full bg-accent-100 px-3.5 py-1.5 text-xs font-bold text-accent-800">
              <i className="ri-verified-badge-line" />
              公开可溯
            </span>
          </div>
        </div>

        <div className="flex flex-col gap-3">
          {FAQS.map((item, idx) => {
            const isOpen = openIdx === idx;
            return (
              <div
                key={item.q}
                className="overflow-hidden rounded-2xl border border-background-200 bg-background-100 transition-colors"
              >
                <button
                  type="button"
                  onClick={() => setOpenIdx(isOpen ? -1 : idx)}
                  aria-expanded={isOpen}
                  className="flex w-full items-center gap-4 p-5 text-left"
                >
                  <span
                    className={`flex h-9 w-9 shrink-0 items-center justify-center rounded-xl text-sm font-bold transition-colors ${
                      isOpen ? "bg-primary-500 text-background-50" : "bg-secondary-100 text-secondary-800"
                    }`}
                  >
                    Q{idx + 1}
                  </span>
                  <span className="flex-1 font-heading text-base font-bold text-foreground-950">{item.q}</span>
                  <i
                    className={`text-lg text-foreground-400 transition-transform ${isOpen ? "ri-subtract-line" : "ri-add-line"}`}
                  />
                </button>
                {isOpen && (
                  <div className="px-5 pb-5 pl-[72px]">
                    <p className="text-sm leading-7 text-foreground-600">{item.a}</p>
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}